import React, { useState } from 'react';
import { Menu, X, LogIn } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const NavBarMain = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
    setIsMenuOpen(false);
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          
          {/* Logo Section - Left Side */}
          <div className="flex items-center space-x-2">
            <div className="relative">
              {/* Nova Logo Icon */}
              <NavLink to="/" className="btn btn-ghost p-0">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-xl flex items-center justify-center shadow-md">
                  {/* <span className="text-white font-bold text-xl">N</span> */}
                  <img src="./images-pub/nova-logo.png" alt="NOVA Logo" className="w-10 h-10 rounded-lg" />
                </div>
              </NavLink>
              {/* Small decorative element */}
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full animate-pulse"></div>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-700 to-indigo-600 bg-clip-text text-transparent">
                NOVA
              </span>
              <span className="text-[10px] font-semibold text-gray-500 -mt-1 tracking-wider">
                ONLINE TUTORING
              </span>
            </div>
          </div>

          {/* Desktop Navigation Links - Hidden on Mobile */}
          <div className="hidden md:flex items-center space-x-6">
            <NavLink to="/" onClick={scrollToTop} className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">
              Home
            </NavLink>
            <NavLink to="/" onClick={scrollToTop} className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">
              Subjects
            </NavLink>
            <NavLink to="/" onClick={scrollToTop} className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">
              Tutors
            </NavLink>
            <NavLink to="/about" onClick={scrollToTop} className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">
              About
            </NavLink>
            <NavLink to="/" onClick={scrollToTop} className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">
              Contact
            </NavLink>  
          </div>

          {/* Login Button - Right Side (Desktop) */}
          <div className="hidden md:flex items-center space-x-3">
            <button onClick={() => {window.location.href = 'https://elearn.novaonlinetuition.com';}} className="btn btn-outline btn-primary gap-2">
              <LogIn size={18} />
              Login
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-600 hover:text-gray-900 focus:outline-none"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu - Dropdown */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-3">
              <a
                href="/"
                className="text-gray-700 hover:text-blue-600 font-medium px-2 py-2 rounded-lg hover:bg-blue-50 transition-colors"
                onClick={scrollToTop}
              >
                Home
              </a>
              <a
                href="/"
                className="text-gray-700 hover:text-blue-600 font-medium px-2 py-2 rounded-lg hover:bg-blue-50 transition-colors"
                onClick={scrollToTop}
              >
                Subjects
              </a>
              <a
                href="/"
                className="text-gray-700 hover:text-blue-600 font-medium px-2 py-2 rounded-lg hover:bg-blue-50 transition-colors"
                onClick={scrollToTop}
              >
                Tutors
              </a>
              <a
                href="/about"
                className="text-gray-700 hover:text-blue-600 font-medium px-2 py-2 rounded-lg hover:bg-blue-50 transition-colors"
                onClick={scrollToTop}
              >
                About
              </a>
              <a
                href="/"
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200 px-2 py-2 rounded-lg hover:bg-blue-50"
                onClick={scrollToTop}
              >
                Contact
              </a>
              <div className="pt-3 flex flex-col space-y-2">
                <button onClick={() => {window.location.href = 'https://elearn.novaonlinetuition.com';}} className="btn btn-outline btn-primary w-full gap-2">
                  <LogIn size={18} />
                  Login
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBarMain;